<div class="hero">
  <div class="container hero-container" fxLayout="column-reverse" fxLayout.gt-sm="row" fxLayoutAlign="space-between center">
    <ng-content select="[hero-content]">
    </ng-content>
    <div class="hero-image-container">
      <ng-content select="[hero-image]">
      </ng-content>
    </div>
  </div>
</div>
<div class="container">
  <ng-content select="[hero-back-button]"></ng-content>
</div>